import { Component, OnInit, AfterViewInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {VideoGridElement} from '../../_shared/videos-grid/video-grid-element.model';

@Component({
    selector: 'app-marineaircraft',
    templateUrl: './marineaircraft.component.html',
    styleUrls: ['./marineaircraft.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MarineaircraftComponent implements OnInit, AfterViewInit {

  @ViewChild('staticTabs', { static: false }) staticTabs: TabsetComponent;
  id: number;

  videos: VideoGridElement[] = [
    {
      url: 'https://www.youtube.com/embed/mFKosAFIjSQ',
      title: 'Assessor\'s Boat & Vessel Owners Town Hall 2024',
      powerpoint: 'https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1680545747/Webinars%20and%20Presentations/Assessor_571-L_Seminar_Overview_2023_-_Final.pdf'
    }
  ];

  selectTab(tabId: number) {
    this.staticTabs.tabs[tabId].active = true;
  }
  constructor(private actRoute: ActivatedRoute) {
    this.id = this.actRoute.snapshot.params.id;
  }
  ngAfterViewInit() {
    console.log(this.id);
    this.selectTab(this.id - 1);
  }

  ngOnInit() {

  }


}
